import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

const SpaceLocationMap = ({
  activeSpace = null,
}) => {
  const { t } = useTranslation("global");
  
  // Your existing API key from environment variables
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
  // Default center coordinates for Paris, France
  const defaultCenter = {
    lat: 48.8566,
    lng: 2.3522
  };

  // Get the embed URL for Google Maps - requires API key but is free to use
  const getEmbedUrl = () => {
    if (!googleMapsApiKey) return "";
    
    let lat, lng;
    
    if (activeSpace?.address?.lat && activeSpace?.address?.lng) {
      lat = parseFloat(activeSpace.address.lat);
      lng = parseFloat(activeSpace.address.lng);
    } else {
      lat = defaultCenter.lat;
      lng = defaultCenter.lng;
    }
    
    const zoom = (activeSpace?.address?.lat && activeSpace?.address?.lng) ? 15 : 12;
    
    // Google Maps Embed API - free with API key, $0 cost for embed usage
    return `https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${lat},${lng}&zoom=${zoom}`;
  };

  const handleOpenGoogleMaps = () => {
    let destinationLat, destinationLng;
    
    if (activeSpace?.address?.lat && activeSpace?.address?.lng) {
      destinationLat = parseFloat(activeSpace.address.lat);
      destinationLng = parseFloat(activeSpace.address.lng);
    } else {
      destinationLat = defaultCenter.lat;
      destinationLng = defaultCenter.lng;
    }
    
    const googleMapsURL = `https://www.google.com/maps/search/?api=1&query=${destinationLat},${destinationLng}`;
    window.open(googleMapsURL, "_blank", "noopener,noreferrer");
  };

  // Format address for display
  const getFormattedAddress = () => {
    if (!activeSpace?.address) {
      return "Paris, France";
    }
    
    const { street, city, zipCode } = activeSpace.address;
    const parts = [];
    
    if (street) parts.push(street);
    if (city) parts.push(city);
    if (zipCode) parts.push(zipCode);
    
    return parts.join(", ");
  };

  // Show error if API key is missing
  if (!googleMapsApiKey) {
    return (
      <div className={styles.map}>
        <div className={styles.errorContainer}>
          <p>Google Maps API key is missing. Please check your .env file.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.map}>
      <div className={styles.mapContainer}>
        <div className={styles.embeddedMapWrapper}>
          {/* Google Maps Embed iframe - free with API key */}
          <iframe
            title="Location Map"
            src={getEmbedUrl()}
            width="100%"
            height="400px"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className={styles.embeddedMap}
          />
          
          <div className={styles.mapOverlay}>
            <div className={styles.mapBtns}>
              <button
                onClick={handleOpenGoogleMaps}
                className={styles.openGoogleMapsButton}
                type="button"
              >
                {t("global:openInGoogleMaps", "Open in Google Maps")}
              </button>
            </div>
            
            <div className={styles.locationBadge}>
              <span className={styles.address}>
                {getFormattedAddress()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpaceLocationMap;